import * as React from "react";

export default function AttHistoryTable({ data }) {
  return (
    <table className="w-full">
      <thead>
        <tr className="border-b  text-sm sm:text-base">
          <th className="text-left py-3 px-4 font-medium text-muted-foreground">
            Student Name
          </th>
          <th className="text-left py-3 px-4 font-medium text-muted-foreground">
            Batch Code
          </th>
          <th className="text-left py-3 px-4 font-medium text-muted-foreground">
            Date
          </th>
          <th className="text-left py-3 px-4 font-medium text-muted-foreground">
            Status
          </th>
        </tr>
      </thead>
      <tbody>
        {data?.map((record: AttendanceRecord, index) => (
          <tr
            key={index}
            className="border-b last:border-0 hover:bg-muted transition-colors  text-sm sm:text-base"
          >
            <td className="py-3 px-4">{record.studentName}</td>
            <td className="py-3 px-4">{record.batchCode}</td>
            <td className="py-3 px-4">
              {new Date(record.date).toLocaleDateString()}
            </td>
            <td className="py-3 px-4">
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  record.attendence
                  ? "bg-teal-100 text-[#49ccc1e2]"
                    : "bg-red-100 text-red-800"
                }`}
              >
                {record.attendence ? "Present" : "Absent"}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
